import { number, object, array, boolean } from '@gogame/schemas';

import {
  ACTIVITY,
  METRIC,
  TRAFFIC,
  GENRES,
  APPLICATIONS,
  NETWORKS,
  PLATFORMS,
  COUNTRIES,
  REGISTRATIONS,
  SAME_AS_FIRST,
  FRAUD,
} from './constants';

export const kpiSeriesSchema = object({
  [ACTIVITY]: number().required('Activity is required'),
  [METRIC]: number().required('Metric is required'),
  [TRAFFIC]: number().required('Traffic type is required'),
  [GENRES]: array(number()),
  [APPLICATIONS]: array(number()),
  [NETWORKS]: array(number()),
  [PLATFORMS]: array(number()),
  [COUNTRIES]: array(number()),
  [REGISTRATIONS]: number(),
  [FRAUD]: number(),
  [SAME_AS_FIRST]: boolean(),
}).default({
  [ACTIVITY]: 1,
  [TRAFFIC]: 2,
  [REGISTRATIONS]: 1,
  [SAME_AS_FIRST]: false,
  [FRAUD]: 1,
});
